import { MATERIAL_ICON_ITEM_MAP } from "@/constants/materialIcon";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import { SOURCE_TYPE_NAMES } from "@/constants/sourceTypeIcon";
import useAppStore from "@/context/store";
import { getContentType } from "@/utils/getContentType";
import getNextDetailsSetp from "@/utils/getHistorySetp";
import { Dropdown } from "antd";
import classNames from "classnames";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Case, Switch, When } from "react-if";
import { EVENT } from "../../constants/event";
import { cancelShieldPin, report, shieldPin } from "../../services";
import displayNum from "../../utils/displayNum";
import imageUrl from "../../utils/imageUrl";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import Image from "../Image";
import { useLogin } from "../LoginModal";
import ReportModal from "../ReportModal";
import styles from "./index.module.less";
import PinVideo from "./video";
const PinPreview = dynamic(import("../PinPreview"), { ssr: false });

const shieldReasonList = [
  "内容不感兴趣",
  "不喜欢这张采集",
  "图片质量差",
  "其他",
];

export default function PinCard({
  record,
  hideUser,
  showBoardLink = true,
  showDownload = false,
  disableModal,
  disableFile,
  fullWidth,
  isModal,
  showMaterialTag = true,
  onMouseEnterCard,
  onMouseLeaveCard,
}) {
  const { user, pinOpenType, vips } = useAppStore(
    ({ user, pinOpenType, vips }) => ({
      user,
      pinOpenType,
      vips,
    })
  );

  const [hover, setHover] = useState(false);
  const [play, setPlay] = useState(false);
  const [pin, setPin] = useState(record);
  const [bgColor, setBgColor] = useState(record?.file?.theme || "EDF2F5");
  const { login } = useLogin();
  const router = useRouter();
  const currentSrcRef = useRef(null);
  const imageRef = useRef(null);

  const isGif = useMemo(() => {
    return pin.file?.type === "image/gif";
  }, [pin]);
  const meterialCategory = useMemo(() => {
    return pin.file_material?.material_category;
  }, [pin]);
  const isVideo = useMemo(() => {
    return meterialCategory === "视频模板" || meterialCategory === "视频";
  }, [meterialCategory]);

  const contentType = useMemo(() => {
    return getContentType(pin?.extra);
  }, [pin]);
  const videoTime = useMemo(() => {
    let duration = pin.file_material?.extra?.duration;
    duration = ~~(duration / 1000);
    const hh = Math.floor(duration / 3600);
    duration -= hh * 3600;
    const mm = Math.floor(duration / 60);
    duration -= mm * 60;
    const ss = duration;
    const appendZeroStr = (num) => (num < 10 ? "0" + num : num);
    return `${appendZeroStr(mm)}:${appendZeroStr(ss)}`;
  }, [pin]);

  useEffect(() => {
    const onUpdate = (evt) => {
      const record = evt.detail;
      if (record?.pin_id === pin?.pin_id) {
        // 保留feed流中特殊属性，避免feed流中 sourceType 相关字段丢失
        setPin({
          ...pin,
          ...record,
        });
      }
    };

    window.addEventListener(EVENT.UPDATE_PIN, onUpdate);

    return () => {
      window.removeEventListener(EVENT.UPDATE_PIN, onUpdate);
    };
  }, [pin]);

  const onHover = useCallback(
    (hover) => {
      setHover(hover);
      if (!isVideo) {
        setPlay(true); // gif图移动上去后永远播放
      }
    },
    [isVideo]
  );

  const onDetail = useCallback(
    (evt) => {
      if (evt.metaKey || evt.ctrlKey || pinOpenType === PIN_OPEN_TYPE.BLANK) {
        return;
      }
      onHover(false);
      onMouseLeaveCard && onMouseLeaveCard(pin);

      evt.preventDefault();

      if (disableModal) {
        // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
        window._pinDetailCurrentSrc = currentSrcRef.current;
        router.push(`/pins/${pin.pin_id}`);
        return;
      }
      useAppStore.setState({
        currentPin: {
          ...pin,
          pinId: pin.pin_id,
          // 用于渐进式显示图片，先显示缓存图，再显示大图
          currentSrc: currentSrcRef.current,
          ...(!disableFile ? { file: pin.file } : null),
        },
      });
      // 弹窗内切换需要记录push的步骤
      let detailsSetp = getNextDetailsSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      window.history.pushState(
        isModal ? { ...historyData, detailsSetp } : null,
        null,
        `/pins/${pin.pin_id}`
      );
    },
    [
      pinOpenType,
      onHover,
      onMouseLeaveCard,
      pin,
      disableModal,
      disableFile,
      isModal,
      router,
    ]
  );

  // 跳转对象详情
  const onLinkFollowerDetail = (pin) => {
    const { source_type, source_detail } = pin;
    let source_link = "";

    if (source_type === 1) {
      // 画板
      source_link = `/boards/${source_detail?.board_id}`;
    } else if (source_type === 2) {
      // 用户
      source_link = `/user/${source_detail?.urlname}`;
    } else if (source_type === 3) {
      // 来源
      source_link = `/domains/${source_detail?.domain_id}`;
    }
    window.open(source_link);
  };

  const onImgLoad = useCallback((evt) => {
    currentSrcRef.current = evt.target.currentSrc;
    setBgColor(null);
  }, []);

  const userDom = useMemo(() => {
    return (
      <a
        className={styles.user}
        href={`/user/${pin.user?.urlname}`}
        target="_blank"
        rel="noreferrer"
        data-gd-click="button_click"
        data-button-name="去个人页"
        data-content-id={pin.pin_id}
        data-board-id={pin.board_id}
        title={pin.user?.username}
      >
        <div className={styles.avatar}>
          <img
            alt={pin.user?.username || "查看用户"}
            src={imageUrl(pin.user?.avatar, { width: 75, rect: "sq" })}
            loading="lazy"
          />
        </div>
        <div className={styles.name}>{pin.user?.username}</div>
      </a>
    );
  }, [pin]);

  const boardDom = useMemo(() => {
    return (
      <div className={styles.board}>
        <a
          className={styles.link}
          href={`/boards/${pin.board_id}`}
          data-gd-click="button_click"
          data-button-name="去画板"
          target="_blank"
          title={pin.board?.title || "查看画板"}
          rel="noreferrer"
        >
          <div className={styles.label}>画板</div>
          <div className={styles.title}>{pin.board?.title}</div>
        </a>
        <PinPreview className={styles.button} pin={pin} />
      </div>
    );
  }, [pin]);

  const onReport = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: record?.pin_id,
      reportContentId: record?.file_material?.material_id,
      reportFileId: record?.file_id,
      contentType: contentType,
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: record?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  }, [login, record, user, contentType]);

  /** 屏蔽 */
  const onShield = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    const result = await shieldPin({
      item_type: 1,
      item_value: pin?.file_id,
    });

    if (!result.err) {
      setPin((pin) => ({
        ...pin,
        shieldStatus: "reason",
      }));
      // 必须更新一下，不然瀑布流销毁状态就会消失
      record.shieldStatus = "reason";
    }
  }, [login, pin, user, record]);

  /** 取消屏蔽*/
  const onCancelShield = useCallback(async () => {
    const result = await cancelShieldPin({
      item_type: 1,
      item_value: pin?.file_id,
    });

    if (!result.err) {
      setPin((pin) => ({
        ...pin,
        shieldStatus: "",
      }));
      // 必须更新一下，不然瀑布流销毁状态就会消失
      record.shieldStatus = "";
    }
  }, [pin, record]);

  /** 屏蔽原因 */
  const onShieldReason = useCallback(
    async (reason) => {
      const result = await shieldPin({
        item_type: 1,
        item_value: pin?.file_id,
        reason,
      });

      if (!result.err) {
        setPin((pin) => ({
          ...pin,
          shieldStatus: "show",
        }));
        // 必须更新一下，不然瀑布流销毁状态就会消失
        record.shieldStatus = "show";
      }
    },
    [pin, record]
  );

  const moreMenu = useMemo(() => {
    return (
      <div
        className={styles.menu}
        data-content-type={contentType}
        style={pin.source_type ? { width: 240 } : {}}
        title={
          pin.source_type
            ? `此采集来自你关注的${SOURCE_TYPE_NAMES[pin.source_type]} ${
                pin.source_detail?.domain_name ||
                pin.source_detail?.title ||
                pin.source_detail?.username
              }`
            : undefined
        }
      >
        {pin.source_type && (
          <div className={styles.source}>
            此采集来自你关注的{SOURCE_TYPE_NAMES[pin.source_type]}
            <span onClick={() => onLinkFollowerDetail(pin)}>
              {pin.source_detail?.domain_name ||
                pin.source_detail.title ||
                pin.source_detail.username}
            </span>
          </div>
        )}
        <a
          className={styles.menuItem}
          onClick={onShield}
          data-gd-click="button_click"
          data-button-name="屏蔽"
          data-report-type="采集"
          data-report-pin-id={record?.pin_id}
          data-report-file-id={record?.file_id}
          data-report-content-id={record?.file_material?.material_id}
        >
          <span className={styles.text}>屏蔽采集</span>
        </a>
        <a
          className={styles.menuItem}
          onClick={onReport}
          data-gd-click="button_click"
          data-button-name="举报"
          data-report-type="采集"
          data-report-pin-id={record?.pin_id}
          data-report-file-id={record?.file_id}
          data-report-content-id={record?.file_material?.material_id}
        >
          <span className={styles.text}>举报采集</span>
        </a>
      </div>
    );
  }, [onReport, onShield, record, pin, contentType]);

  const wrapRef = useRef();

  const onMouseLeave = useCallback(
    (e) => {
      const rect = wrapRef.current.getBoundingClientRect();

      // 鼠标位置
      const x = e.clientX;
      const y = e.clientY;

      // 卡片位置
      const left = rect.left;
      const right = rect.right;
      const top = rect.top;
      const bottom = rect.bottom;

      // 判断鼠标是否在卡片内，+1-1是为了解决缓慢移出边界时会有误差情况
      if (x <= left + 1 || x >= right - 1 || y <= top + 1 || y >= bottom - 1) {
        onHover(false);
        onMouseLeaveCard && onMouseLeaveCard(pin);
      }
    },
    [onHover, onMouseLeaveCard, pin]
  );

  const onMouseEnter = useCallback(() => {
    onHover(true); // 解决关闭弹窗后，没有触发鼠标MouseEnter事件
    onMouseEnterCard?.({
      pin,
      imageDom: imageRef.current,
      onUpdatePin: setPin,
    });
  }, [onHover, onMouseEnterCard, pin]);

  const onOperate = () => {
    // 关注页面需要记录用户有没有操作
    if (router.pathname === "/follow") {
      window.dispatchEvent(new Event(EVENT.CARD_OPERATE));
    }
  };

  return (
    <div
      ref={wrapRef}
      className={classNames(styles.card, {
        [styles.fullWidth]: fullWidth,
      })}
      data-pin-id={pin.pin_id}
      onClick={onOperate}
      // onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseOver={onMouseEnter}
    >
      <div className={styles.container}>
        {/* 图片 */}
        <div
          ref={imageRef}
          className={styles.img}
          data-gd-expose="content_expose"
          data-gd-click="material_click"
          data-unique-id={pin.pin_id}
          data-content-id={pin.pin_id}
          data-content-type={contentType}
          data-material-id={pin.extra?.material_id}
          data-ext={JSON.stringify(pin?.ext)}
          data-board-id={pin.board_id}
          data-file-id={pin.file_id}
          data-check-cover
          style={bgColor ? { backgroundColor: `#${bgColor}` } : null}
        >
          {fullWidth && (pin.repin_count || pin.text_meta?.creation) && (
            <div className={styles.info}>
              <When condition={pin.repin_count}>
                <div className={styles.item}>
                  <div
                    className={styles.num}
                    title={`转采：${pin.repin_count}`}
                  >
                    <HBIcon className={styles.icon} type="ic_zc1" />
                    <div className={styles.text}>
                      {displayNum(pin.repin_count)}
                    </div>
                  </div>
                </div>
              </When>
              <When condition={pin.text_meta?.creation}>
                <div className={styles.item}>
                  <HBIcon className={styles.draw} type="draw2" />
                  <span className={styles.text}>原创</span>
                </div>
              </When>
            </div>
          )}
          <div className={styles.bottomInfo}>
            {showMaterialTag &&
              pin.file_material?.status === 2 &&
              MATERIAL_ICON_ITEM_MAP[meterialCategory] && (
                <div className={styles.material}>
                  <div
                    className={styles.icon}
                    style={{
                      backgroundColor:
                        MATERIAL_ICON_ITEM_MAP[meterialCategory].color,
                    }}
                  >
                    <HBIcon
                      type={MATERIAL_ICON_ITEM_MAP[meterialCategory].icon}
                    />
                  </div>
                  <div className={styles.text}>
                    {/* {showDownload
                      ? user && vips.length > 0
                        ? pin.file_material?.material_type?.toUpperCase() ||
                          "素材"
                        : "商用授权"
                      : "素材"} */}
                    {MATERIAL_ICON_ITEM_MAP[meterialCategory].label}
                  </div>
                </div>
              )}
            {isGif && !isVideo && !play && (
              <div className={styles.gif}>GIF</div>
            )}
            {isVideo && !hover && (
              <div className={styles.video}>{videoTime}</div>
            )}
          </div>
          <a
            className={styles.link}
            href={`/pins/${pin.pin_id}`}
            target="_blank"
            onClick={onDetail}
            rel="noreferrer"
          >
            {isVideo && hover && <PinVideo fullWidth={fullWidth} pin={pin} />}

            <Image
              className="transparent-img-bg"
              alt={pin.raw_text}
              src={imageUrl(pin.file, {
                width: fullWidth ? 1200 : 240,
                gif: play && isGif,
              })}
              srcSet={
                imageUrl(pin.file, {
                  width: fullWidth ? 1200 * 2 : 480,
                  gif: play && isGif,
                }) + " 2x"
              }
              width={Math.min(fullWidth ? 1200 : 240, pin.file?.width)}
              height={Math.round(
                (pin.file?.height / pin.file?.width) *
                  Math.min(fullWidth ? 1200 : 240, pin.file?.width)
              )}
              loading="lazy"
              style={bgColor ? { background: "none" } : null}
              onLoad={onImgLoad}
              showError={true}
              title={pin.raw_text}
            />
          </a>
        </div>
        {/* 用户信息 */}
        <When condition={!hideUser || showBoardLink}>
          <div className={styles.info}>
            <Switch>
              <Case condition={!hideUser && showBoardLink}>
                <div className={styles.left}>{userDom}</div>
                <div className={styles.right}>{boardDom}</div>
              </Case>
              <Case condition={hideUser && showBoardLink}>{boardDom}</Case>
              <Case condition={!hideUser && !showBoardLink}>{userDom}</Case>
            </Switch>
          </div>
        </When>
        <When condition={!fullWidth}>
          <div className={styles.operation} data-content-type={contentType}>
            <div className={styles.left}>
              <div className={styles.button} title={`转采：${pin.repin_count}`}>
                <HBIcon className={styles.icon} type="ic_zc1" />
                {pin.repin_count > 0 && (
                  <div className={styles.text}>
                    {displayNum(pin.repin_count)}
                  </div>
                )}
              </div>
              <div className={styles.button} title={`喜欢：${pin.like_count}`}>
                <HBIcon
                  className={classNames([
                    styles.icon,
                    pin.liked ? styles.active : null,
                  ])}
                  type={pin.liked ? "ic_favorite" : "ic_like"}
                />

                {pin.like_count > 0 && (
                  <div className={styles.text}>
                    {displayNum(pin.like_count)}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.right}>
              <Dropdown overlay={moreMenu} placement="bottomRight">
                <div className={styles.button}>
                  <HBIcon className={styles.icon} type="ic_more" />
                </div>
              </Dropdown>
            </div>
          </div>
        </When>
      </div>
      {pin?.shieldStatus && (
        <div className={styles.shield}>
          <div className={styles.text}>
            {pin?.shieldStatus === "reason"
              ? "已屏蔽，请告诉我们原因为你优化推荐结果"
              : "已收到你的反馈，将为你优化推荐结果"}
          </div>
          {pin?.shieldStatus === "reason" && (
            <div className={styles.reason}>
              {shieldReasonList.map((reason, index) => (
                <div
                  className={styles.item}
                  key={index}
                  onClick={() => onShieldReason(reason)}
                  data-gd-click="button_click"
                  data-button-name="屏蔽原因"
                  data-report-reason={reason}
                  data-content-id={record?.pin_id}
                  data-board-id={record?.board_id}
                  data-file-id={record?.file_id}
                  data-report-content-id={record?.file_material?.material_id}
                >
                  {reason}
                </div>
              ))}
            </div>
          )}
          <div className={styles.linkContainer}>
            <a className={styles.link} onClick={onCancelShield}>
              取消屏蔽
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
